/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
/* eslint-disable react/no-danger */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, {
  useState, useEffect,
} from 'react';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import styled from '@emotion/styled';
import ResizeObserver from 'react-resize-observer';
import { Field } from 'formik';
import IcomoonReact from 'icomoon-react';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import { TransitionGlobal } from '../../../../shared/GlobalStyles';
import Text from '../../../../shared/components/Text/Text';
import VideoAndUrlInput from './VideoAndUrlInputs';
import {
  setActiveSecondLayerModal, fetchDocument, addAsset,
} from '../../ducks/calendarActions';
import { showErrorToast } from '../../../../shared/utils/toastManager';

const DescriptionContainer = styled('div')`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const LiftInputsContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const LiftInputsRow = styled('div')`
  display: flex;
  flex-direction: ${(props) => (props.containerWidth < 528 ? 'column' : 'row')};
  gap: 32px;
`;

const LiftInputsSubContainer = styled('div')`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 16px;
`;

const StyledTextArea = styled('textarea')`
  width: 100%;
  height: 100%;
  min-height: 82px !important;
  padding: 10px;
  font-size: 16px;
  border: ${(props) => (props.error && props.touched ? '1px solid #CC0404' : '1px solid #ccc')};
  border-radius: 4px;
  font-family: 'Nunito Sans';
  color: #444444;
  &:focus {
    outline: none;
    border-color: #ccc;
    box-shadow: none;
  }
  ::placeholder {
    color: #9E9E9E;
  }
  
  :disabled {
    background: white;
    border-color: #EEEEEE;
    color: #BDBDBD;
  }
`;

const AddAssetButtonContainer = styled('div')`
  display: flex;
  gap: 4px;
  cursor: pointer;
  align-items: center;
  transition: ${TransitionGlobal};
  :hover {
    opacity: 0.7;
  }
`;

const AssetButtonContainer = styled('div')`
  position: relative;
  display: flex;
  gap: 4px;
  border: 1px solid #EEEEEE;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 8px;
  padding-right: 8px;
  cursor: pointer;
  align-items: center;
  border-radius: 4px;
  width: fit-content;
`;

const ClearAssetIconContainer = styled('div')`
  position: absolute;
  top: -8px;
  right: -8px;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: #E0E0E0;
  padding: 4px;
  cursor: pointer;
  transition: ${TransitionGlobal};
  :hover {
    opacity: 0.7;
  }
`;

const AddAssetsColumn = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
`;

const NameAndInputContainer = styled('div')`
  display: flex;
  gap: 8px;
  align-items: center;
  .checkbox-input {
    appearance: none; /* Remove default checkbox styling */
    min-width: 18px;
    min-height: 18px;
    max-width: 18px;
    max-height: 18px;
    border: 2px solid #E0E0E0;
    border-radius: 4px;
    outline: none;
    cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
    position: relative;
    transition: ${TransitionGlobal};
    :hover {
      opacity: 0.7;
    }
  }
  .checkbox-input:checked {
    border: ${(props) => (props.disabled ? '2px solid #E0E0E0' : '2px solid #77A7FF')};
   }

  .checkbox-input:checked::after {
    content: '';
    position: absolute;
    top: 1px;
    left: 5px;
    width: 5px;
    height: 10px;
    border: ${(props) => (props.disabled ? 'solid #E0E0E0' : 'solid #77A7FF')};
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    display: block;
  }

`;

const ExerciseManagementWarning = styled('div')`
  display: flex;
  gap: 12px;
  background: #FFFBEB;
  border: 2px solid #FFCB47;
  border-radius: 8px;
  align-items: center;
  padding: 8px 16px;
  margin-bottom: 11px;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.3px;
  line-height: 1.4;
  color: #333333;
  p {
    font-size: 9pt;
  }
`;

const WarningAndInputContainer = styled('div')`
display: flex;
flex-direction: column;
`;

const IconContainer = styled('div')`
display: flex;
min-width: 16px;
`;

const NotesFormInputs = ({
  errors,
  touched,
  mediaType,
  videoUrlValue,
  mediaUrlValue,
  setFieldValue,
  setFieldTouched,
  setFieldError,
  urlButtonValue,
  containerWidth,
  reusableItemValue,
  hasExerciseManagementAccess,
}) => {
  const dispatch = useDispatch();
  const assetToAdd = useSelector((state) => state.calendar.data.addAsset);
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const accountCode = currentUser?.accountCode;
  const modalData = useSelector((state) => state.calendar.data.modalData);
  const [addAssetsColumnContainerWidth, setAddAssetsColumnContainerWidth] = useState(0);

  useEffect(() => {
    if (assetToAdd) {
      setFieldValue('documentId', assetToAdd?.id);
    }
  }, [assetToAdd]);

  return (
    <LiftInputsContainer>
      <LiftInputsRow containerWidth={containerWidth}>
        <VideoAndUrlInput
          errors={errors}
          touched={touched}
          mediaType={mediaType}
          videoUrlValue={videoUrlValue}
          mediaUrlValue={mediaUrlValue}
          setFieldValue={setFieldValue}
          urlButtonValue={urlButtonValue}
          containerWidth={containerWidth}
          setFieldTouched={setFieldTouched}
          setFieldError={setFieldError}
          isDisabled={modalData?.disabledEditModal}
        />
        <LiftInputsSubContainer>
          <WarningAndInputContainer>
            {!hasExerciseManagementAccess && !modalData?.disabledEditModal && (
            <ExerciseManagementWarning>
              <IconContainer>
                <IcomoonReact
                  iconSet={iconSet}
                  size={16}
                  icon='warning'
                  color='#F59E0B'
                />
              </IconContainer>
              <Text>You do not have the user permissions required to save to the exercise database.</Text>
            </ExerciseManagementWarning>
            )}
            <NameAndInputContainer disabled={modalData?.disabledEditModal || !hasExerciseManagementAccess}>
              <input
                disabled={modalData?.disabledEditModal || !hasExerciseManagementAccess}
                className='checkbox-input'
                type='checkbox'
                name='reusableItem'
                onChange={() => {
                  setFieldValue('reusableItem', !reusableItemValue);
                }}
                checked={reusableItemValue}
              />
              <Text color={(modalData?.disabledEditModal || !hasExerciseManagementAccess) && '#BDBDBD'} fontSize='16px' style={{ whiteSpace: 'nowrap ' }}>Save to Database</Text>
            </NameAndInputContainer>
          </WarningAndInputContainer>
          <DescriptionContainer>
            <Text
              fontSize='16px'
              fontWeight={700}
              color={modalData?.disabledEditModal && '#BDBDBD'}
            >
              Description
            </Text>
            <Field
              name='description'
              className='form-control'
              render={({ field }) => (
                <StyledTextArea disabled={modalData?.disabledEditModal} {...field} error={errors.description} touched={touched.description} />
              )}
            />
            {errors.description && touched.description && (
            <Text color='#CC0404' fontSize='13px' fontWeight={700} style={{ marginTop: '5px' }}>{errors.description}</Text>
            )}
          </DescriptionContainer>
          <AddAssetsColumn>
            <ResizeObserver
              onResize={(rect) => {
                setAddAssetsColumnContainerWidth(rect?.width);
              }}
            />
            {modalData?.disabledEditModal ? null : (
              <Text fontSize='16px' fontWeight={700}>Attach Document/Link</Text>
            )}
            {assetToAdd ? (
              <AssetButtonContainer onClick={() => {
                const docId = assetToAdd?.id;
                if (assetToAdd.type === 1) {
                  dispatch(fetchDocument(({ accountCode, docId }), {
                    onSuccess: (response) => {
                      window.open(response?.url, '_blank');
                    },
                    onError: () => {
                      showErrorToast('Opps! Something went wrong. Unable to fetch document.');
                    },
                  }));
                }
                if (assetToAdd.type === 2) {
                  window.open(assetToAdd?.url, '_blank');
                }
              }}
              >
                <ClearAssetIconContainer onClick={(e) => {
                  dispatch(addAsset(null));
                  setFieldValue('documentId', null);
                  e.stopPropagation();
                }}
                >
                  <IcomoonReact
                    iconSet={iconSet}
                    size={10}
                    icon='remove'
                    color='#9E9E9E'
                  />
                </ClearAssetIconContainer>
                <IcomoonReact
                  iconSet={iconSet}
                  size={14}
                  icon='link'
                  color='#9E9E9E'
                />
                <Text
                  style={{
                    maxWidth: `${addAssetsColumnContainerWidth - 60}px`,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                  }}
                  fontSize='16px'
                  color='#9E9E9E'
                >
                  {assetToAdd?.name}
                </Text>
              </AssetButtonContainer>
            ) : (
              <>
                {!modalData?.disabledEditModal && (
                <AddAssetButtonContainer onClick={() => dispatch(setActiveSecondLayerModal('addAssetModal'))}>
                  <IcomoonReact
                    iconSet={iconSet}
                    size={12}
                    icon='plus'
                    color='#77A7FF'
                  />
                  <Text fontSize='16px' color='#77A7FF'>Add Asset</Text>
                </AddAssetButtonContainer>
                )}
              </>
            )}
          </AddAssetsColumn>
        </LiftInputsSubContainer>
      </LiftInputsRow>
    </LiftInputsContainer>
  );
};

export default NotesFormInputs;
